<template>
<div class="update-leaps-affirmation-overlay">
   <div class="container-fluid">
      <div id="myNav" class="overlay overlay-overall-width-100Perc">
          <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
              <div class="row">
                <div class="col-md-12 col-lg-12">
                  <div class="text-right close-text-font-style margin-right-2Perc margin-top-2Perc cursor-pointer" v-on:click="updateHideUpdateLeapsAffirmationOverlayFlag($event,true)">
                    <img src= "../../../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-3Perc float-right" alt="close-icon">
                  </div>  
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right">
                  <span>Title</span>
                  <span class="text-color-red">*</span>
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12 padding-left-0Px">
                      <input type="text" class="form-control" v-model="objToPass.AffirmationTitle" :maxlength="maxLength">
                    </div>
                  </div>
                </div>
                <div class="col-md-2 col-lg-2"></div>
                <div class="col-md-2 col-lg-2 text-align-left create-lesson-input-text-style">
                  <div class="form-group">
                  </div>
                </div>
                <div class="col-md-2 col-lg-2"></div>  
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  <span>Description</span>
                  <span class="text-color-red">*</span>
                </div>
                <div class="col-md-9 col-lg-9 padding-left-0Px">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <tinymce id="d1" v-model="objToPass.AffirmationDescription"></tinymce>
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1">
                </div>  
              </div>

              <div class="row margin-bottom-2Perc">
                <div class="col-md-5 col-lg-5">
                </div>  
                <div class="col-md-2 col-lg-2">
                  <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="updateLeapsAffirmation">Update</button>
                </div>  
                <div class="col-md-5 col-lg-5">
                </div>
              </div>
              <div class="row">
              </div>         
          </div>
      </div>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box> 
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
        <div class="osahanloading"></div>
      </div>
      <loader></loader>
 </div>
 </div>
</template>

<script>
import findIndex from 'lodash/findIndex'
import tinymce from 'vue-tinymce-editor'
import { constants } from '@/utils/constants'
import AlertBox from '@/components/AlertOverlay'
import { leapsAffirmationService } from '@/server-util/leaps-affirmation-service'
import Loader from '@/components/dashboard/Loader'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
export default {
  props: ['currSelectedObj'],
  created: function () {
    this.setDefaultValues()
  },
  data: function () {
    return {
      constants: constants,
      maxLength: constants.Leaps_Title_Max_Length,
      showAlertDialog: false,
      errorMsg: '',
      objToPass: {
        AffirmationLibraryId: '',
        AffirmationTitle: '',
        AffirmationDescription: '',
        CreatedTS: '',
        UpdatedTS: ''
      },
      showSpinner: false,
      hasUpdatedLeapsAffirmationSuccessfully: false,
      createdObj: null
    }
  },
  name: 'update-leaps-affirmation-overlay',
  methods: {
    setDefaultValues: function () {
      this.objToPass.AffirmationLibraryId = this.currSelectedObj.AffirmationLibraryId
      this.objToPass.AffirmationTitle = this.currSelectedObj.AffirmationTitle
      setTimeout(() => {
        this.objToPass.AffirmationDescription = (this.currSelectedObj.AffirmationDescription !== undefined && this.currSelectedObj.AffirmationDescription !== 'undefined' && this.currSelectedObj.AffirmationDescription !== null && this.currSelectedObj.AffirmationDescription !== 'null' && this.currSelectedObj.AffirmationDescription !== '') ? dmAdminUtils.updateUrls(this.currSelectedObj.AffirmationDescription) : ''
      }, 500)
      this.objToPass.CreatedTS = this.currSelectedObj.CreatedTS
      this.objToPass.UpdatedTS = this.currSelectedObj.UpdatedTS
    },
    updateHideUpdateLeapsAffirmationOverlayFlag: function (event, flagToUpdate) {
      var objToReturn = {
        closeOverlay: true,
        createdObj: null
      }
      this.$emit('emittedValue', objToReturn)
    },
    checkAndUpdateMasterLeapAffirmationList: function () {
      const foundIndex = findIndex(this.$store.state.leapsAffirmationList, (obj) => {
        return obj.AffirmationLibraryId === this.objToPass.AffirmationLibraryId
      })
      if (foundIndex > -1) {
        this.$store.state.leapsAffirmationList[foundIndex] = this.createdObj
      }
    },
    updateLeapsAffirmation: function () {
      var storeObj = this.$store
      if (this.validateRequiredFieldBeforeSubmit()) {
        if (
          storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== ''
        ) {
          this.objToPass.AffirmationDescription = (this.objToPass.AffirmationDescription !== undefined && this.objToPass.AffirmationDescription !== 'undefined' && this.objToPass.AffirmationDescription !== null && this.objToPass.AffirmationDescription !== 'null' && this.objToPass.AffirmationDescription !== '' && this.objToPass.AffirmationDescription.trim().length !== 0) ? dmAdminUtils.removeTFromUrls(this.objToPass.AffirmationDescription) : null
          this.$store.state.isLoading = true
          leapsAffirmationService
            .updateLeapsAffirmation(
              storeObj.state.access_token,
              this.objToPass
            )
            .then(responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                this.hasUpdatedLeapsAffirmationSuccessfully = true
                this.createdObj = responseObj.data
                this.checkAndUpdateMasterLeapAffirmationList()
                this.showAlertDialog = true
                this.errorMsg = '\'' + this.objToPass.AffirmationTitle + '\' affirmation updated successfully.'
                this.$store.state.isLoading = false
              } else {
                this.$store.state.isLoading = false
                this.showAlertDialog = true
                this.errorMsg = 'Oops! Something went wrong. Please try again.'
              }
            }, errorObj => {
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            })
        } else {
          console.log(
            'Access Token is NULL hence declined UPDATE EXISTING LEAPS AFFIRMATION.'
          )
        }
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
      if (this.hasUpdatedLeapsAffirmationSuccessfully) {
        // AK: Hide Update LEAPS Affirmation Overlay
        var objToReturn = {
          closeOverlay: true,
          createdObj: this.createdObj
        }
        this.$emit('emittedValue', objToReturn)
        this.hasUpdatedLeapsAffirmationSuccessfully = false
        this.createdObj = null
      }
    },
    stripHtml: function (html) {
      // Create a new div element
      var temporalDivElement = document.createElement('div')
      // Set the HTML content with the providen
      temporalDivElement.innerHTML = html
      // Retrieve the text property of the element (cross-browser support)
      return temporalDivElement.textContent || temporalDivElement.innerText || ''
    },
    validateRequiredFieldBeforeSubmit: function () {
      if (this.objToPass.AffirmationTitle.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Title can\'t be empty.'
        return false
      } else if (this.stripHtml(this.objToPass.AffirmationDescription).trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Description can\'t be empty.'
        return false
      }
      return true
    }
  },
  components: {
    'alert-box': AlertBox,
    'loader': Loader,
    'tinymce': tinymce
  },
  computed: {}
}
</script>

<style scoped>
.text-color-red {
  color: red;
}
.margin-Top-Bottom-1Point5Perc {
  padding-top: 1.5%;
  padding-bottom: 1.5%;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.red{
  background-color: red;
}
.MainDiv
{
  overflow-y: hidden !important;
}
.margin-Top-0Perc{
  margin-top: 0%;
}
.margin-Top-1Perc{
  margin-top: 1%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-Top-3Perc
{
	margin-top: 3%;
}
.margin-Top-8Perc
{
	margin-top: 8%;
}
.margin-bottom-0Perc
{
	margin-bottom: 0%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2%;
}
.margin-left-0Perc
{
    margin-left:0%;
}
.margin-left-1Perc
{
    margin-left:2%;
}
.margin-left-2Perc
{
    margin-left:2%;
}
.margin-left-3Perc{
  margin-left:3%;
}
.margin-left-4Perc
{
    margin-left:4%;
}
.margin-left-5Perc{
  margin-left:5%;
}
.margin-left-6Perc{
  margin-left:6%
}
.margin-left-9Perc
{
    margin-left:9%;
}
.padding-Left-0px
{
  padding-left: 0px !important;
}
.padding-Left-30px
{
  padding-left: 3% !important;
}
.text-align-center
{
  text-align: center;
}
.left-border
{
  border-left: 1px solid #aaa;
}

.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.text-align-left
{
  text-align: left;
}
.font-size-1-3vw
{
  font-size: 1.3vw;
}
.font-size-20px
{
  font-size: 20px;
}
.background-gray{
  background-color: #ddd;

}

.border-rounded{
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}

  .overflow-x-hidden{
    overflow-x: hidden !important;
  }
  .font-size-18px {
  font-size: 18px;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.width-70Perc {
  width: 70%;
}
.width-90Perc {
  width: 90%;
}
.margin-auto{
margin: auto;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-content {
  position: relative;
  top: 7%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.center-aligned-div {
  margin: 0 auto;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.background-color-white {
  background-color: #ffffff !important;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.float-right {
  float: right;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 17px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.padding-left-0Px {
  padding-left: 0px !important;
}
switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.text-align-right {
  text-align: right;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color
{
  color: #000 !important;
}
</style>





// WEBPACK FOOTER //
// src/components/leaps/affirmation/UpdateLeapsAffirmationOverlay.vue